/**
 * Rotas disponíveis na aplicação.
 */
export enum TypesRoutes {
  START = '/',
  LANDING_PAGE = '/landing-page',
  REQUEST_SENT = '/request-sent',
}
